export const selectUsersData = state => state.users.data

export const selectUsersLoadingState = state => state.users.loading
